/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Broker } from "./Broker";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const BrokersR = t.interface({
  brokers: t.readonlyArray(Broker, "array of Broker"),

  page_info: PageInfo
});

// optional attributes
const BrokersO = t.partial({});

export const Brokers = t.intersection([BrokersR, BrokersO], "Brokers");

export type Brokers = t.TypeOf<typeof Brokers>;
